import PropTypes from 'prop-types';
import accessIcon from 'assets/icons/access.svg';
import Box from 'components/UI/Box/Box';

const Card = ({
  title = '',
  titleClassName = '',
  description = '',
  descriptionClassName = '',
  image = '',
  imageClassName = '',
  showAccessIcon = false,
  body = null,
  children = null,
  icon = null,
  onClick = null,
}) => {
  return (
    <Box padding='sm' className='mb-2 flex items-center'>
      <div className='flex justify-between gap-2 w-full' onClick={onClick}>
        {image && <img src={image} alt='card-icon' className={imageClassName} />}
        <div className='flex justify-between items-center gap-2 w-full'>
          <div className='w-full'>
            <div className={`font-bold ${titleClassName}`}>{title}</div>
            <div className={`${descriptionClassName || 'text-neutral-500 text-sm'}`}>{description}</div>
            {body || children}
          </div>
          {showAccessIcon && <img src={accessIcon} alt='access' />}
          {icon}
        </div>
      </div>
    </Box>
  );
};

Card.propTypes = {
  title: PropTypes.string,
  titleClassName: PropTypes.string,
  description: PropTypes.string,
  descriptionClassName: PropTypes.string,
  onClick: PropTypes.func,
  image: PropTypes.string,
  imageClassName: PropTypes.string,
  showAccessIcon: PropTypes.bool,
  body: PropTypes.node,
  children: PropTypes.node,
  icon: PropTypes.node,
};

export default Card;
